var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-nav',{attrs:{"showMenu":false}}),_vm._t("default"),_c('main-footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }